import axios from 'axios'
import load from "@/LOAD.js";
import store from "@/vuex/index.js"
import storage from "./storage.js"


const instance = axios.create({
  baseURL: load.getUrl(),
})


// ----------------------------------
// ------------ REQUEST -------------
// ----------------------------------
instance.interceptors.request.use(config => {

  // Controllo consegne
  if (config.url.indexOf("consegne") != -1)
    config.baseURL = load.getUrlConsegneInternet()

  // Imposto il token
  if (store.getters['auth/isAuthenticated'])
    config.headers.Authorization = storage.getAuthHeader()

  return config

}, function (error) {

  // Do something with request error
  console.log("return request interceptor" + error)

  return Promise.reject(error)
})


// ----------------------------------
// ------------ RESPONSE ------------
// ----------------------------------
instance.interceptors.response.use(response => {

  return response

}, function (error) {

  let originalRequest = error.config


  // Controllo scadenza token
  if (error.response && error.response.status === 401 && !originalRequest._retry) {

    originalRequest._retry = true

    // Login con refreshToken
    return store.dispatch("auth/refreshToken").then(authResponse => {

      instance.defaults.headers.common['Authorization'] = 'Bearer ' + authResponse.data.access_token;
      originalRequest.headers['Authorization'] = 'Bearer ' + authResponse.data.access_token

      return instance(originalRequest)

    })
      .catch(err => {
        console.log(error)

        // NOTA: se il token non è stato rinnovato dal refresh token, non posso fare la dispatch per registrare il logout,
        //       ma devo pulire il token
        store.commit("auth/DEL_TOKEN")

      });


  }

  console.log("return response interceptor" + error)

  return Promise.reject(error);

})

export default instance